import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import { Button } from '@material-ui/core';
import dp from "../pages/AddEditContributor/assets/blank-profile.png";

const styles = theme => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    // width: 500,
    height: 450,
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  button : {
    backgroundColor : theme.palette.secondary.main,
    color : "white"
  }
});

/**
 * The example data is structured as follows:
 *
 * import image from 'path/to/image.jpg';
 * [etc...]
 *
 * const tileData = [
 *   {
 *     img: image,
 *     title: 'Image',
 *     displayName: 'displayName',
 *   },
 *   {
 *     [etc...]
 *   },
 * ];
 */
function TitlebarGridList(props) {
  const { classes } = props;
  const  addElement = (arr,val) => {
    return [...arr,val];
  }
  const  removeElement = (arr,val) => {
    return arr.filter(displayName=> displayName!==val);
  }
  return (
    <div className={classes.root}>
      <GridList cellHeight={180} className={classes.gridList} cols={2}>
        {/* <GridListTile key="Subheader" cols={3} style={{ height: 'auto' }}>
          <ListSubheader component="div">Follow Contributors</ListSubheader>
        </GridListTile> */}
        {props.data.map((tile,id) => (
          <GridListTile key={tile.profilePic+id}>
            <img src={tile.profilePic ? tile.profilePic.uri : dp} alt={""} />
            <GridListTileBar
              // title={tile.title}
              style={{display: "inline-block", textAlign: "center", height:"75px"}}
              // subtitle={<span>by: {tile.displayName}</span>}
              actionIcon={
                <div>
                {/* <IconButton onClick={() => props.onChange(props.value.indexOf(tile.displayName)===-1?addElement(props.value,tile.displayName):removeElement(props.value,tile.displayName))} className={classes.icon}>
                  {props.value.indexOf(tile.displayName)===-1?<StarBorderIcon className={classes.title} />:<StarIcon className={classes.title} color="secondary" />}
                </IconButton> */}
                <div style={{color:"#fff",marginBottom:"5px"}}>{tile.displayName}</div>
                <div>{props.value.indexOf(tile.displayName)===-1?<Button variant="contained" onClick={() => props.onChange(addElement(props.value,tile.displayName))}>Follow</Button>:<Button variant="contained" className={classes.button} onClick={() => props.onChange(removeElement(props.value,tile.displayName))} >Unfollow</Button>}</div>
                </div>
              }
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
}

TitlebarGridList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(TitlebarGridList);
